<template>
  <div>
    <div class="contents">
      <article class="article-header row g-0">
        <div class="col-12">
          <h5>{{ view.title }}</h5>
        </div>
        <div class="d-flex flex-column flex-lg-row">
          <div class="d-flex flex-column flex-md-row text-black">
            <span>
              <i class="material-icons">person</i>
              {{ view.firstname }} {{ view.lastname }}
            </span>
            <span class="mx-md-3 my-3 my-md-0">
              <i class="material-icons">phone_in_talk</i>
              {{ view.phone }}
            </span>
            <span>
              <i class="material-icons-outlined">email</i>
              {{ view.email }}
            </span>
          </div>
          <div class="ms-lg-auto mt-3 mt-lg-0">
            <span class="me-2 text-date">
              <i class="material-icons">date_range </i>
              {{ view.timezone_date | dateformat }}
            </span>
            <span>
              <i class="material-icons">visibility</i>
              {{ view.cnt | comma }}
            </span>
          </div>
        </div>
      </article>

      <article class="article-body">
        <span v-html="view.content"></span>
      </article>

      <article class="article-footer">
        <div class="prev" :class="!next_post.inquiry_pk && 'no-data'">
          <router-link
            :to="{
              name: 'InquiryView',
              params: { inquiryno: next_post.inquiry_pk },
            }"
            v-if="next_post.inquiry_pk"
          >
            <i class="material-icons-outlined"> expand_less </i>
            <span>{{ next_post.title }}</span>
          </router-link>
          <a @click="_alert($t('text.support.no_prev'))" v-else class="pointer">
            <i class="material-icons-outlined"> expand_less </i>
            <span>{{ $t("text.support.no_prev") }}</span>
          </a>
        </div>
        <div class="next" :class="!prev_post.inquiry_pk && 'no-data'">
          <router-link
            :to="{
              name: 'InquiryView',
              params: { inquiryno: prev_post.inquiry_pk },
            }"
            v-if="prev_post.inquiry_pk"
          >
            <i class="material-icons-outlined"> expand_more </i>
            <span>{{ prev_post.title || $t("text.support.no_next") }}</span>
          </router-link>
          <a @click="_alert($t('text.support.no_next'))" v-else class="pointer">
            <i class="material-icons-outlined"> expand_more </i>
            <span>{{ $t("text.support.no_next") }}</span>
          </a>
        </div>
      </article>

      <div class="btn-bottom-wrapper">
        <b-button
          size="xl"
          variant="outline-secondary"
          :aria-label="$t('button.common.list')"
          @click="$router.push({ name: 'InquiryList' })"
          >{{ $t("button.common.list") }}</b-button
        >
        <b-button
          size="xl"
          variant="primary"
          :aria-label="$t('button.common.delete')"
          @click="Delete"
          >{{ $t("button.common.delete") }}</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import "@/filter/common";
import ax from "@/api/support";
import { myMixin } from "@/mixin/myMixin";

export default {
  name: "view",
  data() {
    return {
      param: {
        searchtype: this.$route.query.searchtype || 1,
        searchname: this.$route.query.searchname || "",
      },
      view: {
        title: null,
        content: null,
        firstname: null,
        lastname: null,
        phone: null,
        email: null,
        date: null,
        viewflag: null,
        deleteflag: null,
      },
      next_post: {},
      prev_post: {},
      inquiryno: this.$route.params.inquiryno || "",
    };
  },
  methods: {
    getView() {
      if (this.inquiryno) {
        ax.getInquiryView(this.inquiryno, this.param, (flag, data) => {
          if (flag) {
            this.view = data.inquiryview;
            this.next_post = data.next_post;
            this.prev_post = data.prev_post;
          } else {
            alert(data);
          }
        });
      }
    },
    Delete() {
      ax.getInquiryDelete(this.inquiryno, (flag, data) => {
        if (flag) {
          alert(data.message);
          this.$router.push({ name: "InquiryList" });
        } else {
          alert(data.message);
        }
      });
    },
  },
  created() {
    this.getView();
  },
  watch: {
    "$route.params": function () {
      this.inquiryno = parseInt(this.$route.params.inquiryno);
      this.getView();
    },
  },
  mixins: [myMixin],
};
</script>
